import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';
import { MigrationData , TrafficHistoryEntry } from './MigrationData';
import { CountryList } from './GroupedCountryList';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class DataService {

  private DataUrl = 'assets/data.json';
  private countriesUrl = 'assets/countries.json';

  constructor( private http: HttpClient ) { }

  getMigrationData (): Observable<MigrationData> {
    return this.http.get<MigrationData>(this.DataUrl);
  }

  getCountries (): Observable<CountryList> {
    return this.http.get<CountryList>(this.countriesUrl);
  }

}



// WEBPACK FOOTER //
// D:/Workspace/hyblab-migration/src/app/data.service.ts